import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { 
  PafLabelDirective,
  PaftooltipDirective, 
  PafplaceholderDirective,
  OnlyNumbersDirective,
  DraganddropDirective,
  DebounceClickDirective,
  UpperCaseTextDirective,
  ColumnDateDirective,
  ColumnTimeDirective,
  ColumnDatetimeDirective,
  PilotageEndelContainerDirective,
   TextareaAutoresizeDirective, 
   BrowserTabLinkDirective,
   ConvertToNumberDirective
 } from '../all-directives';
 


@NgModule({
  imports:[
    CommonModule
  ],
  declarations:[
    PafLabelDirective,
    PafplaceholderDirective,
    OnlyNumbersDirective,
    DraganddropDirective,
    DebounceClickDirective,
    UpperCaseTextDirective,
    ColumnDateDirective,
    ColumnTimeDirective,
    ColumnDatetimeDirective,
    PilotageEndelContainerDirective,
    TextareaAutoresizeDirective,
    BrowserTabLinkDirective,
    PaftooltipDirective,
    ConvertToNumberDirective
    ]
  ,exports:[
    PafLabelDirective,
    PafplaceholderDirective,
    OnlyNumbersDirective,
    DraganddropDirective,
    DebounceClickDirective,
    UpperCaseTextDirective,
    ColumnDateDirective,
    ColumnTimeDirective,
    ColumnDatetimeDirective,
    PilotageEndelContainerDirective,
    TextareaAutoresizeDirective,
    BrowserTabLinkDirective,
    PaftooltipDirective,
    ConvertToNumberDirective
    ]
})
export class PafAllDirectivesModule{}
